import { useState, useEffect } from 'react'
import TrendChart from './TrendChart'
import { getCreatorAppTrends, type VisitorTrendPoint } from '../../lib/api'
import { TrendingUp } from 'lucide-react'

interface VisitorTrendChartProps {
  appName: string
}

export default function VisitorTrendChart({ appName }: VisitorTrendChartProps) {
  const [data, setData] = useState<VisitorTrendPoint[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getCreatorAppTrends(appName)
      .then(setData)
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [appName])

  if (loading) return <div className="h-64 animate-pulse bg-secondary rounded-xl" />
  if (!data.length) return null

  return (
    <div className="p-6 rounded-xl border border-border bg-card">
      <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">
        <TrendingUp className="w-5 h-5" />
        Visitor Trends <span className="text-xs font-normal text-muted-foreground">(30 days)</span>
      </h2>
      <TrendChart
        data={data}
        lines={[
          { dataKey: 'visits', label: 'Total Visits', color: '#3b82f6' },
          { dataKey: 'unique_visitors', label: 'Unique Visitors', color: '#8b5cf6' },
        ]}
        height={250}
      />
    </div>
  )
}
